import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ROUTES } from '../config/routes';
import Layout from '../components/layout/Layout';

// Lazy load pages for performance
const Home = lazy(() => import('../pages/Home'));
const Experience = lazy(() => import('../pages/Experience'));
const Projects = lazy(() => import('../pages/Projects'));
const Skills = lazy(() => import('../pages/Skills'));
const Education = lazy(() => import('../pages/Education'));
const ResumeView = lazy(() => import('../pages/ResumeView'));
const CoverLetterView = lazy(() => import('../pages/CoverLetterView'));

const AppRouter = () => {
  return (
    <Suspense fallback={<div className="flex h-screen items-center justify-center bg-dark-bg text-accent-green font-mono">Loading...</div>}>
      <Routes>
        <Route path={ROUTES.HOME} element={<Layout />}>
          <Route index element={<Home />} />
          <Route path={ROUTES.EXPERIENCE} element={<Experience />} />
          <Route path={ROUTES.PROJECTS} element={<Projects />} />
          <Route path={ROUTES.SKILLS} element={<Skills />} />
          <Route path={ROUTES.EDUCATION} element={<Education />} />
          <Route path={ROUTES.RESUME} element={<ResumeView />} />
          <Route path={ROUTES.COVER_LETTER} element={<CoverLetterView />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AppRouter;
